import React, { useEffect } from "react";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import movieBanner from "../../../assets/img/movie-banner.jpg";
import { Typography } from "@material-ui/core";
import { Favorite ,ThumbUp} from "@material-ui/icons";
import '../index.css'
const responsive = {
  superLargeDesktop: {
    // the naming can be any, depends on you.
    breakpoint: { max: 4000, min: 3000 },
    items: 1,
  },
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 4,
    
  },
  tablet: {
    breakpoint: { max: 1024, min: 480 },
    items: 3,
    partialVisibilityGutter: 30, // this is needed to tell the amount of px that should be visible.
  },
  mobile: {
    breakpoint: { max: 480, min: 0 },
    items: 1,
    partialVisibilityGutter: 0, // this is needed to tell the amount of px that should be visible.
  },
};

export default function MovieList(props) {
  return (
    <>
      <div style={{textAlign:'left',marginBottom:'10px'}}>  <Typography  style={{color:'var(--darker)'}} variant="h5">{props.title}</Typography></div>
     
    <div style={{padding:'10px'}}>
      <Carousel swipeable responsive={responsive} infinite >
        {props.data&&props.data.map(item=>
    <>  <div  className="movie-card">
        <img src={item.Poster}/>
        <div className="movie-stats">
        <Typography component="span">   <Favorite style={{color:'red',fontSize:'1.2rem'}}/>&nbsp;12</Typography>&nbsp;
        &nbsp;
        <Typography component="span">  <ThumbUp style={{color:'green',fontSize:'1.2rem'}}/> &nbsp;8k</Typography>
        </div>
     </div> 
     <div className="movie-info">
     <Typography component="p" classname="clipped-label">{item.Title}</Typography>
     <Typography component="p" style={{color:'var(--lighttextcolor)'}} >Comedy/Drama</Typography>
     </div></>  )}
      
      </Carousel>
      </div>
    </>
  );
}
MovieList.defaultProps={
  title:'Movie List',
  data:[]
}
